import { render, staticRenderFns } from "./img-box.vue?vue&type=template&id=be2575c8&"
import script from "./img-box.vue?vue&type=script&lang=js&"
export * from "./img-box.vue?vue&type=script&lang=js&"
import style0 from "./img-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports